<template>
  <v-container class="ma-0 pa-0 px-2 pt-8">
    <v-progress-linear indeterminate :active="loading"></v-progress-linear>

    <v-row dense justify="center" align="center">
      <v-col cols="12" class="text-center">
        <ValidationObserver ref="observer" v-if="this.user">
          <!-- Form -->
          <!-- Patient -->
          <v-row align="center" justify="space-around" >
            <v-col no-gutters xl="4" lg="4" md="4" sm="4" cols="12" class="pa-0 ma-0" v-if="!params.patient">
              <mb-select
                v-model="params.patient"
                :items="patients"
                itemText="name"
                itemValue="id"
                returnObject
                name="patient"
                label="Paciente"
                :loading="patientsLoading"
                @input="(vl) => { params.patient = vl }"
                />
            </v-col>
          </v-row>
          <!-- CPF -->
          <v-row align="center" justify="space-around" v-if="askCpf" >
            <v-col no-gutters xl="2" lg="2" md="2" sm="2" cols="12" class="pa-0 ma-0">
              <mb-input-cpf
                v-model="cpf"
                name="cpf"
                label="CPF"
              />
            </v-col>
          </v-row>
          <!-- Particular/Covenant -->
          <v-row align="center" justify="space-around" >
            <v-col v-if="!covenantPreseted && !particularPreseted"
              no-gutters xl="8" lg="8" md="8" sm="8" cols="12" class="pa-0 ma-0">
              <v-row align="center" justify="center" >
                <v-col xl="2" lg="2" md="2" sm="2" cols="12">
                  <v-switch v-model="params.payment.particular" v-if="params.payment.price"
                    label="Particular?"
                  />
                </v-col>
                <v-col xl="2" lg="2" md="2" sm="2" cols="12" v-if="!covenantPreseted && !particularPreseted && params.payment.price">
                  OU
                </v-col>
                <v-col xl="4" lg="4" md="4" sm="4" cols="12">
                  <mb-select
                    v-model="params.payment.covenant"
                    :items="covenants"
                    itemText="lbl"
                    itemValue="covenantId"
                    returnObject
                    name="covenant"
                    label="Convênios"
                    :disabled="params.payment.particular"
                    :loading="covenantsLoading"
                    />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- Coupon -->
          <v-row align="center" justify="space-around"
            v-if="params.payment.particular && params.payment.paymentAccountStatus === 'verified'">
            <v-col no-gutters xl="4" lg="4" md="4" sm="4" cols="12">
              <mb-input-text
                v-model="coupon"
                name="coupon"
                label="Tem um cupom?"
                @input="inputCoupon"
                @change="validateCoupon"
                :loading="couponsLoading"
                :appendOuterIcon="(couponValid.loaded && !couponValid.valid) ? 'mdi-close-thick' : null"
                :errorMessage="(couponValid.loaded && !couponValid.valid) ? 'Cupom inválido' : null"
              />
            </v-col>
          </v-row>
          <!-- ServiceChannel -->
          <v-row align="center" justify="space-around" >
            <v-col v-if="!params.serviceChannel.selected || params.serviceChannel.selected.id != -1"
              no-gutters xl="8" lg="8" md="8" sm="8" cols="12" class="pa-0 ma-0">
              <v-row align="center" justify="center" >
                <v-col xl="4" lg="4" md="4" sm="4" cols="12" >
                  <mb-select
                    v-model="serviceChannel"
                    :items="params.serviceChannel.calendarServiceChannels"
                    itemText="name"
                    itemValue="id"
                    returnObject
                    name="serviceChannel"
                    label="Canais de Atendimentos"
                    :loading="covenantsLoading"
                    />
                </v-col>
                <v-col xl="4" lg="4" md="4" sm="4" cols="12" v-if="!params.serviceChannel.calendarServiceChannelUrl">
                  <mb-input-text
                    v-model="serviceChannelUrl"
                    name="serviceChannelUrl"
                    :label="(params.serviceChannel.calendarServiceChannelUrl) ? 'Telefone' : 'Telefone, Usuário ou Link'"
                    rules="required"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- Especiality -->
          <v-row align="center" justify="space-around" >
            <v-col no-gutters xl="5" lg="5" md="5" sm="5" cols="12" v-if="!params.schedule.speciality">
              <mb-select
                v-model="speciality"
                :items="params.schedule.calendarSpecialities"
                itemText="name" itemValue="id" returnObject
                name="schc_calendarSpecialities"
                label="Escolha uma especialidade"
                hideDetails
                rules="required"
                />
            </v-col>
          </v-row>
        </ValidationObserver>

        <v-divider inset></v-divider>

        <!-- Confirm -->
        <v-row align="center" justify="space-around" v-if="validToSchedule">
          <!-- Patient -->
          <v-col no-gutters cols="12">
            Confirma o agendamento para
            <span class="font-weight-bold">{{params.patient.name}}</span>?
          </v-col>
          <!-- CPF -->
          <v-col no-gutters cols="12" v-if="askCpf">
            CPF: <span class="font-weight-bold">{{params.patient.cpf || cpf}}</span>
          </v-col>
          <!-- Speciality -->
          <v-col no-gutters cols="12" class="font-weight-bold" v-if="params.schedule.speciality || speciality">
              Especialidade:
              <span v-if="speciality" class="font-weight-bold">{{speciality.name}}</span>
              <span v-else-if="params.schedule.speciality" class="font-weight-bold">{{params.schedule.speciality.name}}</span>
            </v-col>
          <!-- Date/Time -->
          <v-col no-gutters cols="12">
            {{ params.schedule.date | dateToLongDate }} - {{ params.schedule.time | timeToHM }}
          </v-col>
          <!-- Covenant -->
          <v-col no-gutters cols="12" v-if="!params.payment.particular && params.payment.covenant">
            {{ `Pelo convênio ${params.payment.covenant.covenantName || params.payment.covenant.name}` }}
          </v-col>
          <!-- Particular -->
          <v-col no-gutters cols="12" v-else-if="params.payment.particular && params.payment.price">
            <!-- Particular: {{ params.payment.price | currency }} {{ (coupon) ? `- ${coupon} ${couponValid.couponValue | currency} = ${couponValid.net | currency}` : '' }} -->
            Particular: {{ params.payment.price | currency }}
            <span v-if="coupon && couponValid.valid">- {{coupon}} {{couponValid.couponValue | currency}}  = {{couponValid.net | currency}}</span>
            <!-- + {{couponValid.taxa | currency}} -->
          </v-col>
          <!-- ServiceChannel -->
          <v-col no-gutters cols="12" v-if="params.serviceChannel &&
            params.serviceChannel.selected &&
            params.serviceChannel.selected.id != -1 &&
            !params.serviceChannel.calendarServiceChannelUrl">

            {{ serviceChannel.description }} {{ (serviceChannelUrl) ? `: ${serviceChannelUrl}` : '' }}
          </v-col>

          <v-col no-gutters cols="12" v-else-if="params.serviceChannel.calendarServiceChannelUrl">
            <v-col no-gutters cols="12" class="pa-0 ma-0">
              {{ serviceChannel.description }} Url para atendimento:
            </v-col>
            <v-col no-gutters cols="12" class="pa-0 ma-0 mt-1 mb-4">
              <a target="_blank" rel="noopener noreferrer" :href="params.serviceChannel.calendarServiceChannelUrl">
                {{params.serviceChannel.calendarServiceChannelUrl}}
              </a>
            </v-col>
          </v-col>
        </v-row>

        <!-- Buttons -->
        <v-row align="center" justify="center" class="mt-5">
          <v-col no-gutters xl="4" lg="4" md="4" sm="4" cols="4">
            <mb-text-button name="cf_sc_confirm"
              :disabled="!validToSchedule()"
              @click="schedule"
              :loading="confirmLoading"
              label="Confirmar"
            />
          </v-col>

          <v-col no-gutters xl="4" lg="4" md="4" sm="4" cols="4">
            <mb-text-button name="cf_sc_cancel"
              @click="cancel"
              :primary="false"
              label="Cancelar"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import bus from '@/plugins/eventBus';
import MbSelect from '@/components/general/inputs/MbSelect';
import MbInputText from '@/components/general/inputs/MbInputText';
import MbTextButton from '@/components/general/buttons/MbTextButton';
import MbInputCpf from '@/components/general/inputs/MbInputCpf';

export default {
  data: () => ({
    loading: false,
    params: null,
    query: null,
    showForm: false,
    patients: [],
    coupon: null,
    couponsLoading: false,
    couponValid: {
      loaded: false,
      valid: false,
    },
    cpf: null,
    couponLoading: false,
    patientsLoading: false,
    covenants: [],
    speciality: null,
    serviceChannel: null,
    serviceChannelUrl: null,
    covenantsLoading: false,
    confirmLoading: false,
    particularPreseted: false,
    covenantPreseted: false,
  }),
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
    askCpf() {
      return !this.params.patient.cpf && this.params.payment.particular && this.params.payment.paymentAccountStatus == 'verified';
    },
  },
  created() {
    this.setParams();

    this.showForm = !this.validToSchedule;

    if (this.params.payment.particular === null) {
      this.params.payment.particular = false;
    }

    this.particularPreseted = this.params.payment.particular;
    this.covenantPreseted = this.params.payment.covenant;

    if (!this.params.payment.covenant) {
      this.getCovenants();
    }

    if (this.params.schedule.calendarSpecialities.length === 1) {
      this.speciality = this.params.schedule.calendarSpecialities[0];
      this.params.schedule.speciality = this.speciality;
    }

    if (this.params.serviceChannel && this.params.serviceChannel.selected && this.params.serviceChannel.selected.id != -1) {
      this.serviceChannel = this.params.serviceChannel.selected;
    }
  },
  methods: {
    validToSchedule() {
      return this.params.patient != null
        && this.params.schedule.date != null
        && this.params.schedule.time != null
        && (this.params.schedule.speciality != null || this.speciality != null)
        && (
          ((this.params.payment.particular == null || this.params.payment.particular == false) && this.params.payment.covenant != null)
          || (this.params.payment.particular == true)
        )
        && (this.askCpf) ? this.cpf != null : true;
    },
    setParams() {
      this.query = this.$route.query;
      if (this.query && this.query.q) {
        this.params = JSON.parse(atob(this.query.q));
      }

      if (this.params.schedule.calendarSpecialities) {
        this.params.schedule.calendarSpecialities = JSON.parse(this.params.schedule.calendarSpecialities);
      }

      if (this.params.serviceChannel.calendarServiceChannels) {
        this.params.serviceChannel.calendarServiceChannels = JSON.parse(this.params.serviceChannel.calendarServiceChannels);
      }
    },
    getPatients() {
      this.patientsLoading = true;
      this.$store
        .dispatch('patientDependents/getFamily', this.user.id)
        .then((patients) => {
          this.patients = patients;
        })
        .finally(() => {
          this.patientsLoading = false;
        });
    },
    getCovenants() {
      this.covenantsLoading = true;
      this.$store
        .dispatch('patientCovenants/all', { patientId: this.params.patient.id, calendarId: this.params.schedule.calendarId })
        .then((covenants) => {
          this.covenants = covenants.map((cv) => {
            cv.lbl = `${cv.covenantName} - ${cv.cardNumber}`;
            return cv;
          });

          if (this.covenants.length === 1) {
            this.params.payment.covenant = this.covenants[0];
          }
        })
        .finally(() => {
          this.covenantsLoading = false;
        });
    },
    async schedule() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.confirmLoading = true;

        const scheduleParams = {
          calendarId: this.params.schedule.calendarId,
          scheduleId: this.params.schedule.scheduleId,
          patientId: this.params.patient.id,
          covenantId: (!this.params.particular && this.params.payment.covenant)
            ? (this.params.payment.covenant.covenantId || this.params.payment.covenant.id)
            : null,
          specialityId: (this.params.schedule.speciality) ? this.params.schedule.speciality.id : this.speciality.id,
          price: this.params.payment.price,
          particular: this.params.payment.particular,
          coupon: this.coupon,
        };

        if (this.cpf) {
          scheduleParams.cpf = this.cpf;
        }

        if (this.serviceChannel) {
          scheduleParams.serviceChannelId = this.serviceChannel.id;

          if (this.serviceChannel.name == 'Consultório Online') {
            scheduleParams.serviceChannelUrl = this.params.serviceChannel.calendarServiceChannelUrl;
          } else {
            scheduleParams.serviceChannelUrl = this.serviceChannelUrl;
          }
        }

        this.$store
          .dispatch('calendars/schedule', scheduleParams)
          .then((res) => {
            if (this.params.payment.particular && res.paymentUrl) {
              const queryBase64 = btoa(JSON.stringify(res.paymentUrl));
              this.$router.push({ name: 'payment-process', query: { q: queryBase64 } });
            } else {
              const queryBase64 = btoa(JSON.stringify(res));
              this.$router.push({ name: 'schedule-success', query: { q: queryBase64 } });
            }
          })
          .catch((err) => {
            bus.$emit('message', {
              message: err.response.data.message,
              type: 'error',
            });
          })
          .finally(() => {
            this.confirmLoading = false;
          });
      }
    },
    cancel() {
      this.$router.push({ name: 'home' });
    },
    validateCoupon() {
      this.couponsLoading = true;
      this.$store.dispatch('coupons/validate', {
        calendarId: this.params.schedule.calendarId,
        patientId: this.params.patient.id,
        coupon: this.coupon,
      })
        .then((valid) => {
          this.couponValid = valid;
          this.couponValid.loaded = true;
        })
        .finally(() => {
          this.couponsLoading = false;
        });
    },
    inputCoupon() {
      this.couponValid = {
        loaded: false,
        valid: false,
      };
    },
  },
  components: {
    ValidationObserver,
    MbSelect,
    MbTextButton,
    MbInputText,
    MbInputCpf,
  },
};
</script>
